import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import useSetParamsURL from '../../../../../lib/useSetParamsURL';
import DialogDetalheAgronomo from './DialogDetalheAgronomo';

interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void
}

const ModalDetalheAgronomoContext = createContext<ModalContextType | undefined>(undefined);

export const ModalDetalheAgronomoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const { searchParams, clearSingleParamUrl } = useSetParamsURL();
    const codigo = searchParams.get('detalhe-agronomo')

    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);

    const openModal = (content: string) => {
        setItemValue(content);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-agronomo")
    };

    useEffect(() => {
        if (codigo) setItemValue(codigo)
    }, [codigo])

    return (
        <ModalDetalheAgronomoContext.Provider value={{ openModal, closeModal }}>
            {children}

            {
                (itemValue && isOpen) &&
                <DialogDetalheAgronomo
                    open={isOpen}
                    value={itemValue}
                    handleClose={closeModal}
                />
            }
        </ModalDetalheAgronomoContext.Provider>
    );
};

// Hook para usar o contexto
export const useModalDetalheAgronomo = (): ModalContextType => {
    const context = useContext(ModalDetalheAgronomoContext);
    if (!context) throw new Error('useModal must be used within a ModalProvider');
    return context;
};